export const environment = {
    production: false,
    enablePinLock: false,
    disableSync: false,
    serviceWorker: false,
    version: '1.0.52',
    backwardsCompatibility: '1.0.0',
    minNativeVersion: '1.0.0',
    databaseSchemaVersion: 1001,
    trainingMaterialsDate: '13.08.2019',
    enableSentryMonitoring: true,
    pouchDbAdapter: 'idb',
    latestPrivacyPolicy: 'privacy-policy-20220316',
    diagnosticApi: 'https://diagnostic.de-rena.de',
    diagnosticsSecret: 'hkjhd897d7sadas8sksHSnshe248621njdhe'
};
